import axios from '../axiosApi';
import {
    FETCH_RASPA_CYCLE_HOUR_USAGE_STATISTICS,
    FETCH_RASPA_CYCLES, FETCH_RASPA_REPORT_DATA, FETCH_RASPAS,
    NEW_RASPA_CYCLE,
    NEW_RASPA_CYCLE_SUCCESS,
    RECEIVE_RASPA_CYCLE_HOUR_USAGE_STATISTICS,
    RECEIVE_RASPA_CYCLES, RECEIVE_RASPA_REPORT_DATA, RECEIVE_RASPAS
} from "./actionTypes";

export const fetchRaspaCycles =  () => ({
    type: FETCH_RASPA_CYCLES
});

export const receiveRaspaCycles = payload => ({
    type: RECEIVE_RASPA_CYCLES,
    payload: payload
});

export const fetchRaspas =  () => ({
    type: FETCH_RASPAS
});

export const receiveRaspas = payload => ({
    type: RECEIVE_RASPAS,
    payload: payload
});


export const dpnewRaspaCycle =  () => ({
    type: NEW_RASPA_CYCLE
});

export const dpnewRaspaCycleSuccess = payload => ({
    type: NEW_RASPA_CYCLE_SUCCESS,
    payload: payload
});

export const dpFetchRaspaCycleHourUsageStatistics = () => ({
    type: FETCH_RASPA_CYCLE_HOUR_USAGE_STATISTICS,
    payload: {
        hourUsageTotals: []
    }
});

export const dpReceiveRaspaCycleHourUsageStatistics = payload => ({
    type: RECEIVE_RASPA_CYCLE_HOUR_USAGE_STATISTICS,
    payload: payload
});


export const dpFetchRaspaReportStatistics = () => ({
    type: FETCH_RASPA_REPORT_DATA,
});

export const dpReceiveRaspaReportStatistics = payload => ({
    type: RECEIVE_RASPA_REPORT_DATA,
    payload: payload
});

export const getRaspas = () => {
    return async (dispatch, getState) => {
        dispatch(fetchRaspas());
        console.log('getting Raspas');
        let payload;
        try {
            const state = getState();
            const estabelecimentoId = state.filter.estabelecimentoId;
            const filter = estabelecimentoId
                ? { where: { estabelecimentoId: estabelecimentoId * 1 } }
                : {};
            const response = await axios.get(`/raspas`, { params: { filter: JSON.stringify(filter) } })
            payload = response.data
            console.log('response ', response.data);

        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(receiveRaspas(payload));
        }
    }
};


export const getRaspaCycles = () => {
    return async dispatch => {
        dispatch(fetchRaspaCycles());
        console.log('getting RaspaCycles');
        let payload;
        try {
            const response = await axios.get(`/RaspaCycles`)
            payload = response.data
            console.log('response ', response.data);

        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(receiveRaspaCycles(payload));
        }
    }
};

export const newRaspaCycle = (raspaRecipe) => {
    return async dispatch => {
        dispatch(dpnewRaspaCycle());
        let payload;
        try {
            const response = await axios.post(`/RaspaCycles`, raspaRecipe)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            dispatch(dpnewRaspaCycleSuccess(payload));
        }
    }
}

export const getRaspaCycleHourUsageStatistics = () => {
    return async (dispatch, getState) => {
        dispatch(dpFetchRaspaCycleHourUsageStatistics());

        let hourUsageTotals;
        let hourUsageTotalsPerOperator;
        let totalUsageTimePerTypePerDay;
        let buffingStatsPerSaw;
        let buffingStatsPerSawPerOperator;
        let raspaRithmPerOperator;
        let raspaCycles;
        let raspaCycleDistributionByDateAndHour;

        let payload;

        const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;

        try {
            let options1 = {
                "Interval": {
                    "Min": periodMin,
                    "Max": periodMax
                },
                "IntervalComparasion": {
                    "Min": beforeperiodMin,
                    "Max": beforeperiodMax
                },
                "IntervalBenchmark": {
                    "Min": benchperiodMin,
                    "Max": benchperiodMax
                }
            }
            console.log('getting raspacycle data');
            const response1 = await axios.get(`/raspa-ciclos/tempoUsoTotal?intervalo={"min":"${periodMin}","max":"${periodMax}"}`)
            hourUsageTotals = response1.data;
            const response2 = await axios.get(`/raspa-ciclos/tempoUsoTotalPorOperador?intervalo={"min":"${periodMin}","max":"${periodMax}"}`)
            hourUsageTotalsPerOperator = response2.data;
            const response3 = await axios.get(`/raspa-ciclos/tempoUsoTotalPorDia?intervalo={"min":"${periodMin}","max":"${periodMax}"}`)
            totalUsageTimePerTypePerDay = response3.data;
            const response4 = await axios.get(`/raspa-ciclos/estatisticaPorSerra?intervalo={"min":"${periodMin}","max":"${periodMax}"}`)
            buffingStatsPerSaw = response4.data;
            const response6 = await axios.get(`/raspa-ciclos/ritmoPorOperador?intervalo={"min":"${periodMin}","max":"${periodMax}"}`)
            raspaRithmPerOperator = response6.data;

            let url = `/raspa-ciclos/distribuicaoDataHora?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            console.log(url);
            const response8 = await axios.get(url)
            raspaCycleDistributionByDateAndHour = response8.data;
            console.log(response8.data);
        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            payload = {
                hourUsageTotals: hourUsageTotals,
                hourUsageTotalsPerOperator: hourUsageTotalsPerOperator,
                totalUsageTimePerTypePerDay:  totalUsageTimePerTypePerDay,
                buffingStatsPerSaw: buffingStatsPerSaw,
                buffingStatsPerSawPerOperator: buffingStatsPerSawPerOperator,
                raspaRithmPerOperator: raspaRithmPerOperator,
                raspaCycles: raspaCycles,
                raspaCycleDistributionByDateAndHour: raspaCycleDistributionByDateAndHour
            }

            dispatch(dpReceiveRaspaCycleHourUsageStatistics(payload));
        }
    }
};


export const getRaspaReportData = (raspaId) => {
    return async (dispatch, getState) => {
        dispatch(dpFetchRaspaReportStatistics());



        let payload;

        console.log('getRaspaReportData');

        const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;

        try {

            console.log('getting raspacycle data');

            const urlAtual = `/raspa-ciclos/raspaProducaoDados?raspaId=${raspaId}&intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            console.log(urlAtual);
            const urlComparacao = `/raspa-ciclos/raspaProducaoDados?raspaId=${raspaId}&intervalo={"min":"${benchperiodMin}","max":"${benchperiodMax}"}`;
            console.log(urlComparacao);

            const periodoAtual = await axios.get(urlAtual)
            console.log('periodoAtual', periodoAtual);
            const periodoComparacao = await axios.get(urlComparacao)
            console.log('periodoComparacao', periodoComparacao);



            payload = {
                periodo: periodoAtual.data,
                periodoComparacao: periodoComparacao.data
            };




        }
        catch(e) {
            payload = { error: true, periodo: null, periodoComparacao: null };
        }
        finally {



            dispatch(dpReceiveRaspaReportStatistics(payload));
        }
    }
};